import { MatchStatus } from '@repo/types';

export const isPastMatch = (status: MatchStatus) => {
  return status === MatchStatus.FullTime;
};

export const isFutureMatch = (status: MatchStatus) => {
  return status === MatchStatus.NotKickedOff || status === MatchStatus.Postponed || status === MatchStatus.Abandoned;
};

export const isLiveMatch = (status: MatchStatus) => {
  return !isFutureMatch(status) && !isPastMatch(status);
};

export const parseMatchStatus = (status: MatchStatus) => {
  const isLive = !isFutureMatch(status) && !isPastMatch(status);

  return {
    isFutureMatch: isFutureMatch(status),
    isPastMatch: isPastMatch(status),
    isLiveMatch: isLive,
  };
};
